import reducer, { name } from './module';
import saga from './saga';

export * from './module';
export default { saga, name, reducer };
